import styled from 'styled-components';

export const Img = styled.div`
  width: 100%;
  margin-bottom: -2%;

  img {
    width: 100%;
  }
`;
